import { render, staticRenderFns } from "./LocationIconNew.vue?vue&type=template&id=06a2217d"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a2217d')) {
      api.createRecord('06a2217d', component.options)
    } else {
      api.reload('06a2217d', component.options)
    }
    module.hot.accept("./LocationIconNew.vue?vue&type=template&id=06a2217d", function () {
      api.rerender('06a2217d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/LocationIconNew.vue"
export default component.exports